import { isLeadDiscussionSpace, isTaskDiscussionSpace } from "./teamMentions";

/**
 * Particiona a sidebar da Equipe (ordem de exibição: DMs, canais, conversas de equipe).
 * - requestChannels: discussões de solicitação (comportamento original) + discussões de tarefa
 *   (adição); cada tipo segue o mesmo bucket "Conversas de equipe", sem alterar regras da API
 *   de ocultar solicitação encerrada.
 */
export function partitionTeamSidebarSpaces(spaces, matchesSearch = () => true) {
  const channels = [];
  const requestChannels = [];
  const dms = [];

  for (const space of spaces || []) {
    if (!matchesSearch(space)) continue;
    if (space.type === "dm") {
      dms.push(space);
      continue;
    }
    if (space.type === "channel" && (isLeadDiscussionSpace(space) || isTaskDiscussionSpace(space))) {
      requestChannels.push(space);
      continue;
    }
    if (space.type === "channel") {
      channels.push(space);
    }
  }

  return { channels, requestChannels, dms };
}

export function sumSpaceUnreadCount(spaces) {
  return (spaces || []).reduce((sum, space) => sum + (Number(space?.unreadCount) || 0), 0);
}
